module.exports = window["umle.tslib"];